import styled from 'styled-components'
import { transparentize } from 'polished'
import { colors, sizes } from '../../util'

export const SearchWrapper = styled.label`
  position: relative;
  width: 100%;
  display: flex;
  color: ${colors.grey};
  i {
    font-size: ${({ isSticky }) => (isSticky ? '1rem' : '2rem')} !important;
    position: absolute;
    z-index: 2;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 0.5em;
    transition: all 300ms;
  }
  @media (min-width: ${sizes.medium}) {
  }
`

export const SearchInput = styled.input`
  background-color: transparent;
  background-image: none;
  border: none;
  display: block;
  /* height: ${({ isSticky }) => (isSticky ? '0.75rem' : '3rem')}; */
  font-size: ${({ isSticky }) => (isSticky ? '1rem' : '2rem')};
  line-height: 1;
  width: 100%;
  transition: all 300ms;
  position: relative;
  z-index: 1;
  padding: ${({ isSticky }) => (isSticky ? '0.875rem 2rem 0.875rem 2em' : '1rem 4rem 1rem 2em')};
  /* margin: 1rem 0; */
  &:focus {
    background: ${props => transparentize(0.9, props.theme.color)};
    outline-color: #fff;
    outline: none;
  }

  &::placeholder {
    color: ${colors.grey};
  }
`
